import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export function introCircle(elem) {
  const trigger = document.querySelector('[data-home-intro]');
  const targets = document.querySelectorAll('[data-home-circle]');

  if (!trigger || targets.length === 0) return;

  gsap.fromTo(
    '[data-home-circle]',
    {
      scale: 0.025,
    },
    {
      scrollTrigger: {
        trigger: '[data-home-intro]',
        start: 'top bottom',
        end: '10% center',
        scrub: 1,
      },
      scale: 1,
      stagger: 1,
    }
  );
}
export function introScroll() {
  ScrollTrigger.create({
    trigger: '[data-home-pin]',
    start: 'top 20%',
    bottom: 'bottom bottom',
    pin: true,
  });
}
export function stickyScroll() {
  const business = document.querySelector('.p-home-business');
  const businessBg = document.querySelector('.p-home-business__bg');
  const businessInner = document.querySelector('.p-home-business__inner');
  const introTxtWrap = document.querySelector('.p-home-intro__txt-wrap');
  const introStickyHeight = document.querySelector(
    '.p-home-intro__sticky-height'
  );

  if (
    !business ||
    !businessBg ||
    !businessInner ||
    !introTxtWrap ||
    !introStickyHeight
  )
    return;

  // 初期状態のクラスを削除（リロード時の状態リセット）
  document.documentElement.classList.remove('is-intro-txt-fade');
  document.documentElement.classList.remove('is-home-bg');

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.p-home-business',
      scrub: true,
      start: 'center center',
      end: '+=150%',
      pin: true,
      pinSpacing: false,
      onUpdate: (self) => {
        if (self.progress > 0.1) {
          document.documentElement.classList.add('is-intro-txt-fade');
        } else {
          document.documentElement.classList.remove('is-intro-txt-fade');
        }
      },
      // onLeave: () => {
      //   document.documentElement.classList.add('is-home-bg');
      // },
      // onEnterBack: () => {
      //   document.documentElement.classList.add('is-home-bg');
      // },
      // onLeaveBack: () => {
      //   document.documentElement.classList.remove('is-home-bg');
      // },
    },
  });
  tl.to('.p-home-business__bg', {
    scale: 0.98,
    ease: 'ease',
    //      onEnter: () => {
    //   document.documentElement.classList.add('is-intro-txt');
    // },
    // onLeaveBack: () => {
    //   document.documentElement.classList.remove('is-intro-txt');
    // },
    onComplete: () => {
      document.documentElement.classList.add('is-home-bg');
    },
  })
    // .to('.p-home-business__bg', {
    //   scale: 1.02,
    //   ease: 'ease',
    //
    // })
    .to('.p-home-business__inner', {
      opacity: 1,
      ease: 'ease',
      onReverseComplete: () => {
        document.documentElement.classList.remove('is-home-bg');
      },
    });
  //  const introPinTtl = document.querySelector('.p-home-intro__title');
  // const introPinTtlH = introPinTtl.offsetHeight;
  // ScrollTrigger.create({
  // trigger: '.p-home-intro__sticky-height',
  //  start: `center center-=${introPinTtlH}`,
  //  end: '+=99999',
  //   pin: true,
  //   pinSpacing: false,
  //   // onEnter: () => {
  //   //   document.documentElement.classList.add('is-intro-txt');
  //   // }
  // });
  ScrollTrigger.create({
    trigger: '.p-home-intro__txt-wrap',
    start: 'center center',
    end: '+=99999',
    pin: '.p-home-intro__sticky-height',
    pinSpacing: false,
  });
}
export function stickyScrollSp() {
  const business = document.querySelector('.p-home-business');
  const businessBg = document.querySelector('.p-home-business__bg');
  const businessInner = document.querySelector('.p-home-business__inner');
  const introTxtWrap = document.querySelector('.p-home-intro__txt-wrap');
  const introStickyHeight = document.querySelector(
    '.p-home-intro__sticky-height'
  );

  if (
    !business ||
    !businessBg ||
    !businessInner ||
    !introTxtWrap ||
    !introStickyHeight
  )
    return;

  // 初期状態のクラスを削除（リロード時の状態リセット）
  document.documentElement.classList.remove('is-intro-txt-fade');
  document.documentElement.classList.remove('is-home-bg');

  // 初期状態を明示的に設定（チラつき防止）
  gsap.set('.p-home-business__bg', { scale: 0.3 });
  gsap.set('.p-home-business__inner', { opacity: 0 });
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.p-home-business',
      scrub: true,
      start: 'top 30%',
      end: '+=100%',
      pin: true,
      pinSpacing: false,
      onUpdate: (self) => {
        if (self.progress > 0.1) {
          document.documentElement.classList.add('is-intro-txt-fade');
        } else {
          document.documentElement.classList.remove('is-intro-txt-fade');
        }
      },
      // onLeave: () => {
      //   document.documentElement.classList.add('is-home-bg');
      // },
      // onEnterBack: () => {
      //   document.documentElement.classList.add('is-home-bg');
      // },
      // onLeaveBack: () => {
      //   document.documentElement.classList.remove('is-home-bg');
      // },
    },
  });
  tl.to('.p-home-business__bg', {
    scale: 1.02,
    ease: 'ease',
    onComplete: () => {
      document.documentElement.classList.add('is-home-bg');
    },
  }).to('.p-home-business__inner', {
    opacity: 1,
    ease: 'ease',
    onReverseComplete: () => {
      document.documentElement.classList.remove('is-home-bg');
    },
  });
  ScrollTrigger.create({
    trigger: '.p-home-intro__txt-wrap',
    start: 'center center',
    end: '+=99999',
    pin: '.p-home-intro__sticky-height',
    pinSpacing: false,
  });
}
export function isClassHover() {
  const elements = document.querySelectorAll('[data-hover]');
  elements.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      el.classList.add('is-hover');
    });
    el.addEventListener('mouseleave', () => {
      el.classList.remove('is-hover');
    });
  });
}

export function interviewImageHover() {
  const containers = document.querySelectorAll('.p-home-interview__img-item');
  containers.forEach((container) => {
    const svg = container.querySelector('svg');
    if (!svg) return;
    const imageElement = svg.querySelector('image');
    if (!imageElement) return;
    // クロージャでimageElementを保持
    const handleMouseEnter = () => {
      gsap.to(imageElement, {
        scale: 1.15,
        duration: 0.5,
        ease: 'power1.out',
      });
    };

    const handleMouseLeave = () => {
      gsap.to(imageElement, {
        scale: 1,
        duration: 0.5,
        ease: 'power1.out',
      });
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);
  });
}
export function homeParallax() {
  const gallary = document.querySelector('.p-home-business__gallary');

  if (!gallary) return;

  gsap.to('.p-home-business__gallary', {
    y: '-23%',
    ease: 'none',
    scrollTrigger: {
      trigger: '.p-home-business__gallary',
      scrub: true,
      start: 'top top',
      end: 'bottom -=100%',
    },
  });
}

export function footerBounce() {
  const institution = document.querySelector('.p-home-institution');
  const items = document.querySelectorAll('.p-home-institution__img-item');

  if (!institution || items.length === 0) return;

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.p-home-institution',
      start: 'bottom bottom',
    },
  });

  tl.to('.p-home-institution__img-item', {
    opacity: 1,
    duration: 1,
  }).to(
    '.p-home-institution__img-item',
    {
      y: 0,
      duration: 1.5,
      ease: 'bounce.out',
    },
    '<'
  );
}
// スクロールバーの幅を計算してCSS変数に設定
export function setScrollbarWidth() {
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${scrollbarWidth}px`
  );
}
export function loadAddClass() {
  window.addEventListener('load', () => {
    document.body.classList.add('is-loaded');
  });
  window.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(() => {
      document.body.classList.remove('is-initial');
    });
  });
}
export function fadeScale() {
  const tl = gsap.timeline();
  gsap.utils.toArray('.c-lower-fv-figure').forEach((elem, index) => {
    tl.to(
      elem,
      {
        opacity: 1,
        duration: 0.6,
        ease: 'power1.out',
        delay: 0.06,
      },
      '<'
    ).to(
      elem,
      {
        scale: 1,
        duration: 0.4,
        delay: 0.06,
        ease: 'back.out(1.7)',
      },
      '<'
    );
  });
}
export function scrollDirection() {
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    // ドロワーメニューが開いている場合はスクロール検出を無効化
    if (document.documentElement.classList.contains('is-open')) {
      return;
    }

    const currentScrollY = window.scrollY;

    // スクロール位置が0の場合はクラスを削除
    if (currentScrollY === 0) {
      document.documentElement.classList.remove('is-scrollActive');
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY > lastScrollY) {
      document.documentElement.classList.add('is-scrollActive');
    } else if (currentScrollY < lastScrollY) {
      document.documentElement.classList.remove('is-scrollActive');
    }

    lastScrollY = currentScrollY;
  });
}
